import { Injectable } from '@angular/core';
import { catchError, Observable } from 'rxjs';
import { CreateRomTargetDto, RomTargetDto, UpdateRomTargetDto } from '@shared/dto';
import { ApiOptions, ApiParams } from '@shared/interfaces/api-options.interface';
import { AbstractMemberService } from './abstract-member.service';

/**
 * A member's ROM goals: `/members/:memberId/rom-targets` (KH-1434).
 *
 * Keyed on the same three axes as measured ROM (district, side, movement), so a goal can
 * be lined up against a reading without any mapping.
 */
@Injectable({ providedIn: 'root' })
export class MemberRomTargetService extends AbstractMemberService<RomTargetDto, CreateRomTargetDto, UpdateRomTargetDto> {
  override get endpoint(): string {
    return `${this.api$.value}/:memberId/rom-targets/:romTargetId`;
  }

  /** KH-1434 updates a goal with PATCH. */
  override update(
    params: ApiParams,
    dto: Partial<UpdateRomTargetDto> | Partial<UpdateRomTargetDto>[],
    options?: ApiOptions,
  ): Observable<RomTargetDto> {
    return this.http.patch<RomTargetDto>(this.url(params), dto, options).pipe(
      catchError(error => this.handleHttpErrorResponse(error)));
  }
}
